import React from 'react';
//import UnfoldMoreOutlinedIcon from '@material-ui/icons/UnfoldMoreOutlined';
//import { remove } from 'lodash';

import Booking from './Booking';
import Occasion from './Occasion';
import { toOccasionWrapper } from 'utils/commonFunction';

import styles from './Bookings.module.scss';

//FIXME: This Component could be removed and included in the planner page.
export default class Bookings extends React.Component {
  constructor(props) {
    super(props);
    this.bookingReference = React.createRef();
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.bookings !== this.props.bookings) { return true }
    if (nextProps.booking !== this.props.booking) { return true }
    if (nextProps.users !== this.props.users) { return true }
    if (nextProps.packageOwners !== this.props.packageOwners) { return true }
    if (nextProps.notActiveItems !== this.props.notActiveItems) { return true }
    return false;
  }

  // TODO: Future use hooks - https://reactjs.org/docs/hooks-reference.html#useref
  scrollToRef = (reference) => {
    if (reference && reference.current) {
      window.scrollTo(0, reference.current.offsetTop);
    }
  };

  renderBookings(bookings, booking, notActiveItems) {
    const bookingComponents = [];
    const notActiveStops = notActiveItems?.map(i => i?.id) || [];
    const { config } = this.props;

    bookings.forEach((b) => {
      // An occasion is just a booking displayed differently: render it as the
      // Occasion card (which renders its embedded component bookings), keeping
      // the backend sort order of the intermixed list.
      if (b && b.isOccasion) {
        bookingComponents.push(
          <Occasion
            config={config}
            key={b.id}
            occasion={toOccasionWrapper(b)}
            packageOwners={this.props.packageOwners}
            booking={booking}
            notActiveItems={notActiveItems}
            users={this.props.users}
            onSelectBookingFunc={this.props.onSelectBookingFunc}
            onClickSetRouteFunc={this.props.onClickSetRouteFunc}
            onClickSetVirtualFunc={this.props.onClickSetVirtualFunc}
            onPreviewConfirmationFunc={this.props.onPreviewConfirmationFunc}
            onPreviewCodeFunc={this.props.onPreviewCodeFunc}
            onUpdateBookingItemPaymentFunc={this.props.onUpdateBookingItemPaymentFunc}
            onUpdateBookingItemActivityFunc={this.props.onUpdateBookingItemActivityFunc}
            onUpdateBookingManagerFunc={this.props.onUpdateBookingManagerFunc}
            onDeleteBookingManagerFunc={this.props.onDeleteBookingManagerFunc}
            onUpdateBookingDeliveryStatusFunc={this.props.onUpdateBookingDeliveryStatusFunc}
            onMarkBookingReadyFunc={this.props.onMarkBookingReadyFunc}
            onUpdateStopBookingNoteFunc={this.props.onUpdateStopBookingNoteFunc}
            onUpdateBookingItemPriceFunc={this.props.onUpdateBookingItemPriceFunc}
            onClickBookingNote={this.props.onClickBookingNote}
            onClickAddBookingStopFunc={this.props.onClickAddBookingStopFunc}
            onClickAddBookingStopSparkFunc={this.props.onClickAddBookingStopSparkFunc}
            onSelectStopFunc={this.props.onSelectStopFunc}
            googleMapURL={this.props.googleMapURL}
            getProductByIdFunc={this.props.getProductByIdFunc}
            onSwapStopsFunc={this.props.onSwapStopsFunc}
            onPublishBookingFunc={this.props.onPublishBookingFunc}
            onUpdatePersonalisationCheckFunc={this.props.onUpdatePersonalisationCheckFunc}
          />
        );
        return;
      }

      let isExpanded = booking && booking.id === b.id;
      const refProp = isExpanded ? this.bookingReference : null;
      bookingComponents.push(
        <Booking
          config={config}
          key={b.id}
          referenceProperty={refProp}
          booking={b}
          notActiveItems={notActiveStops}
          users={this.props.users}
          isExpanded={isExpanded}
          onSelectBookingFunc={this.props.onSelectBookingFunc}
          onClickSetRouteFunc={this.props.onClickSetRouteFunc}
          onClickSetVirtualFunc={this.props.onClickSetVirtualFunc}
          onPreviewConfirmationFunc={this.props.onPreviewConfirmationFunc}
          onPreviewCodeFunc={this.props.onPreviewCodeFunc}
          onUpdateBookingItemPaymentFunc={this.props.onUpdateBookingItemPaymentFunc}
          onUpdateBookingItemActivityFunc={this.props.onUpdateBookingItemActivityFunc}
          onUpdateBookingManagerFunc={this.props.onUpdateBookingManagerFunc}
          onDeleteBookingManagerFunc={this.props.onDeleteBookingManagerFunc}
          onUpdateBookingDeliveryStatusFunc={this.props.onUpdateBookingDeliveryStatusFunc}
          onUpdateStopBookingNoteFunc={this.props.onUpdateStopBookingNoteFunc}
          onUpdateBookingItemPriceFunc={this.props.onUpdateBookingItemPriceFunc}
          onClickBookingNote={this.props.onClickBookingNote}
          onClickAddBookingStopFunc={this.props.onClickAddBookingStopFunc}
          onClickAddBookingStopSparkFunc={this.props.onClickAddBookingStopSparkFunc}
          onSelectStopFunc={this.props.onSelectStopFunc}
          googleMapURL={this.props.googleMapURL}
          getProductByIdFunc={this.props.getProductByIdFunc}
          onSwapStopsFunc={this.props.onSwapStopsFunc}
          onPublishBookingFunc={this.props.onPublishBookingFunc}
          onUpdatePersonalisationCheckFunc={this.props.onUpdatePersonalisationCheckFunc}
        />
      );
    });

    return bookingComponents;
  }

  render() {
    const { bookings, booking, notActiveItems } = this.props;
    this.scrollToRef(this.bookingReference);

    return <div className={styles.root}>{this.renderBookings(bookings, booking, notActiveItems)}</div>;
  }
}
